import Remote from "stimulus-remote-rails";

export default class extends Remote {
  static targets = ["scroll", "target"];

  connect() {
    super.connect();

    if (this.hasScrollTarget) {
      this.elementPosition =
        this.scrollTarget.getBoundingClientRect().top + window.pageYOffset;
    }
  }

  replaceTarget(event) {
    event.preventDefault();
    event.stopPropagation();
    const [, , xhr] = event.detail;
    const selector = this.element.dataset.target;
    if (!selector) {
      console.warn(
        "[remote#replaceTarget] Missing `data-target` on element:",
        this.element
      );
      return;
    }

    const target = document.querySelector(selector);
    if (!target) {
      console.warn(
        `[remote#replaceTarget] Target not found for selector "${selector}".`,
        this.element
      );
      return;
    }

    if (this.element.dataset.replaceMethod == "inner") {
      target.innerHTML = xhr.response;
    } else {
      target.outerHTML = xhr.response;
    }
  }

  removeTarget(event) {
    event.preventDefault();
    event.stopPropagation();
    const [, , xhr] = event.detail;
    const target = document.querySelector(this.element.dataset.target);
    if (target) {
      target.remove();
    }
  }

  replaceWithSameForm(event) {
    event.preventDefault();
    event.stopPropagation();

    const [, , xhr] = event.detail;

    const doc = new DOMParser().parseFromString(xhr.response, "text/html");
    const replacement = doc.querySelector(
      '[action="' + this.element.attributes["action"].value + '"]'
    ).outerHTML;

    this.element.outerHTML = replacement;

    if (this.hasScrollTarget && this.elementPosition != null) {
      window.scrollTo({
        top: this.elementPosition,
        behavior: "smooth",
      });
    }
  }

  replaceModalWithResponse(event) {
    event.preventDefault();
    event.stopPropagation();

    const [, , xhr] = event.detail;

    const modalContent = this.element.closest(".modal-content");
    if (!modalContent) return;
    modalContent.innerHTML = xhr.response;
  }

  replaceWithError(event) {
    event.preventDefault();
    event.stopPropagation();

    const [, , xhr] = event.detail;

    const doc = new DOMParser().parseFromString(xhr.response, "text/html");

    alert(doc.body.innerHTML);
  }
}
